import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { Provider } from "react-redux";
import { ConfigProvider } from "antd";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import "react-toastify/dist/ReactToastify.css";

// import logo from "./logo.svg";
import "./App.css";
import "./globalstyle.sass";

// import "tailwindcss/tailwind.css";

import Error404 from "./components/404";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./components/Home/Home";
import UsersPage from "./components/Home/UsersPage";
import AdsPage from "./components/Home/AdsPage";
import RequestsPage from "./components/Home/RequestsPage";
import ReportsPage from "./components/Home/ReportsPage";
import Login from "./components/Login/Login";
import CreateUser from "./components/Users/CreateUser";
import UserDetail from "./components/Users/UserDetail";
import AdDetail from "./components/Ads/AdDetail";

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ConfigProvider
            theme={{
              token: {
                fontFamily: "iranyekanRegular",
              },
            }}
          >
            <Router>
              <ScrollToTop />
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/users" component={UsersPage} />
                <Route path="/users/create" component={CreateUser} />
                <Route path="/products" component={AdsPage} />
                <Route path="/requests" component={RequestsPage} />
                <Route path="/reports" component={ReportsPage} />
                <Route path="/usersdetail/:id" component={UserDetail} />
                <Route path="/adsdetail/:id" component={AdDetail} />
                <Route path="/login" component={Login} />
                <Route component={Error404} />
                <Redirect from="*" to="/404" />
              </Switch>
            </Router>
          </ConfigProvider>
        </PersistGate>
      </Provider>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <ToastContainer />
    </div>
  );
}

export default App;
